<template>
    <div>
        <v-icon x-small color="red">mdi-circle-outline</v-icon>
        <v-icon x-small color="red">mdi-circle-outline</v-icon>
        <v-icon x-small color="red">mdi-circle-outline</v-icon>
    </div>
</template>

<script>
export default {
    name: "IconQuantityEmpty"
}
</script>

<style scoped>

</style>
